<template>
  <v-app id="onInpt">


    <!--
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
    
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
         <span class="hidden-sm-and-down">My account</span>
      </v-toolbar-title>

      <v-toolbar-items class="hidden-sm-and-down">
      </v-toolbar-items>
      <v-spacer />
    </v-app-bar>
     -->


    <v-main> 
      <v-container fluid >   
        <v-row no-gutters>  
          
                <v-col cols="8" class="px-1">
                  <v-card>
                  <v-form ref="inptCard1" v-model="inptCard1Valid">
                  <v-card-title>Sales partner: {{ inpt.inpt_naam }}
                  </v-card-title>
                  <v-row no-gutters>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="inpt.inpt_code" readonly label="Id"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="px-1">
                      <v-text-field v-model="inpt.inpt_naam" label="Name" :rules="inpt_naamRules"></v-text-field>
                    </v-col>  
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="8" class="px-1">
                      <v-text-field v-model="inpt.inpt_kontaktp" label="Contact person"></v-text-field>
                    </v-col>  
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="8" class="px-1">
                      <v-text-field v-model="inpt.inpt_adres" label="Address"></v-text-field>
                    </v-col>  
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="inpt.inpt_postcode" label="Postal code"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="px-1">
                      <v-text-field v-model="inpt.inpt_plaats" label="City"></v-text-field>
                    </v-col>    
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3" class="px-1">
                      <v-select v-model="inpt.land_code" :items="land_codeKeuzes" item-value="land_code" item-text="landtaal_oms" label="Country" dense></v-select>
                    </v-col>
                   <v-col cols="3" class="px-1">
                      <v-select v-model="inpt.taal_code" :items="taal_codeKeuzes" item-value="taal_code" item-text="taaltaal_oms" label="Language" dense></v-select>
                    </v-col>
                  </v-row>
                  
                  <v-row no-gutters>
                    <v-col cols="3" class="px-1">
                      <v-text-field v-model="inpt.inpt_tel1_vcs" label="Telephone number" hint="Including country nr:  316234567890" dense></v-text-field>
                    </v-col>
                     <v-col cols="2" class="px-1">
                      <v-text-field v-model="inpt.inpt_tel1_type" label="Type" readonly dense></v-text-field>
                    </v-col>       
                    <v-col cols="3" class="px-1">
                      <v-text-field v-model="inpt.inpt_tel1_oms" label="Remark" placeholder="." dense></v-text-field>
                    </v-col>    
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="3" class="px-1">
                      <v-text-field v-model="inpt.inpt_tel2_vcs" label="Telephone number" hint="Including country nr:  316234567890" dense></v-text-field>
                    </v-col>    
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="inpt.inpt_tel2_type" label="Type" readonly dense></v-text-field>
                    </v-col>       
                    <v-col cols="3" class="px-1">
                      <v-text-field v-model="inpt.inpt_tel2_oms" label="Remark" placeholder="." dense></v-text-field>
                    </v-col>    
                  </v-row>

                   <v-row no-gutters>
                    <v-col cols="8" class="px-1">
                      <v-text-field v-model="inpt.inpt_bank_iban" label="Bank account IBAN for commission payment" dense></v-text-field>
                    </v-col>
                   </v-row> 

                    <v-row no-gutters>
                    <v-col cols="8" class="px-1">
                      <v-text-field v-model="inpt.inpt_api_passwd" readonly label="API Password"></v-text-field>
                    </v-col>  
                  </v-row>
                  
                  
                  <v-row no-gutters>
                    <v-col cols="1" class="px-1"> 
                    <v-btn class="primary ma-2" :disabled="!inptCard1Valid" x-small @click="saveInpt">Save</v-btn>
                    </v-col>
                  </v-row>
                  </v-form>
                  </v-card>
                </v-col>
          </v-row>

      </v-container>
    </v-main>
    <navBar></navBar>
  </v-app>
</template>




<script>
import navBar from "@/components/navBar";
 export default {
  components: {
     navBar
  },
  data() {
    return {
      inpt: {},
      inptCard1Valid: false,
      land_codeKeuzes: [],
      taal_codeKeuzes: [],
      tel_typeKeuzes: [],
      inpt_naamRules: [
          v => (v && v.length >= 3) || "A name is requird"
      ],
    }
    
  },
  mounted() {
    var deze = this;
    this.$axios
      .post("ares/json/biz/inpt/getInpt.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getInpt"
        },
        getInpt: {
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.inpt = res.data.getInpt;
           document.title = res.data.getInpt.inpt_code;
           res.data.getInpt.taal_codeKeuzes.forEach(function(taal) {
              deze.taal_codeKeuzes.push(taal); 
           })
           res.data.getInpt.land_codeKeuzes.forEach(function(land) {
           deze.land_codeKeuzes.push(land);
           if (land.land_codeSelected === true) {
               deze.inpt.land_code = land.land_code; 
            }
          });
          res.data.getInpt.tel_typeKeuzes.forEach(function(teltype) {
              deze.tel_typeKeuzes.push(teltype); 
          });
        }
      });

  },
  methods: {
     saveInpt() { 
      if(this.$refs.inptCard1.validate()) {
      this.$axios
        .post("ares/json/biz/inpt/saveInpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveInpt"
          },
          saveInpt: {
            inpt_encrid: this.inpt.inpt_encrid,
            inpt_naam: this.inpt.inpt_naam,
            inpt_kontaktp: this.inpt.inpt_kontaktp,
            inpt_adres: this.inpt.inpt_adres,
            inpt_postcode: this.inpt.inpt_postcode,
            inpt_plaats: this.inpt.inpt_plaats,
            land_code: this.inpt.land_code,
            taal_code: this.inpt.taal_code,
            inpt_tel1_vcs: this.inpt.inpt_tel1_vcs,
            inpt_tel1_type: this.inpt.inpt_tel1_type,
            inpt_tel1_oms: this.inpt.inpt_tel1_oms,
            inpt_tel2_vcs: this.inpt.inpt_tel2_vcs,
            inpt_tel2_type: this.inpt.inpt_tel2_type,
            inpt_tel2_oms: this.inpt.inpt_tel2_oms,
            inpt_bank_iban: this.inpt.inpt_bank_iban
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveInpt.text,
              color: res.data.saveInpt.color
            });
          }
        })
      }
    },
  }
};

</script> 

